import { render, staticRenderFns } from "./BorradoresBase.vue?vue&type=template&id=4343ee7e"
import script from "./BorradoresBase.vue?vue&type=script&lang=js"
export * from "./BorradoresBase.vue?vue&type=script&lang=js"
import style0 from "./BorradoresBase.vue?vue&type=style&index=0&id=4343ee7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports